baseApp.directive('ngTable', ['$location', '$timeout', '$filter', '$compile', '$state', 'GeneralUtilsService', '$interval', 'IntervalService', function ($location, $timeout, $filter, $compile, $state, GeneralUtilsService,  $interval, IntervalService) {
	return {
		restrict: 'E',
		replace: false,
		scope: {
			tableConfig: '=',
			facets: '@',
			data: '=?',
			aggregationConfig: '=?',
			selectedItems: '=?',
			errors: '=',
			id: '@',
			label: '@',
			datamodified: '=',
			innerTable: '@',
			template: '@',
			isSystemLogin: '=',
			onSuccessfulItemRemove: "=?",
            pinnedItems: '=?',
			searchFor: '=?',
			selectedItemsChanged: '&',
		},
		templateUrl: function (el, attr) {
			if (attr.template) {
				return '/public/' + attr.template;
			}

			return '/public/directives/table.html';
		},
		controller: function ($scope, $element) {
			var DEFAULT_PAGE_SIZE = 10;


			$scope.queryId = 0;
			// selectedIndexes used for outside selection or for display purposes (row selection instead of selectedItems checkbox selection) - to allow for 2 types of selections
			$scope.selectedIndexes = [];
			$scope.openRows = [];
			$scope.loading = false;
			$scope.firstFetch = false;
			$scope.filterSearch = { v :''};

			if (!$scope.tableConfig) {
				return;
			}

			if ($scope.tableConfig.itemsRenderFinished) {
				$scope.itemsRenderFinished = $scope.tableConfig.itemsRenderFinished;
			}




			if ($scope.innerTable) {
				setInnerTable();
			}

			function setInnerTable() {
				var methodsParams = ['showItemDetails', 'processData', 'expand', 'dataURL', 'parseData', 'lookup', 'showPopUp', 'expandRow'];

				methodsParams.forEach(function (method) {
					if ($scope.tableConfig[method]) {
						if (typeof $scope.tableConfig[method] === 'string') {
							$scope.tableConfig[method] = $scope.$parent.tableConfig[$scope.tableConfig[method]];
						} else if ($scope.tableConfig[method] === true) {
							$scope.tableConfig[method] = $scope.$parent.tableConfig[method];
						}
					}
				});
			}

			$scope.lastFilter = {};
			$scope.compiledTemplates = {};
			if (!$scope.selectedItems) {
				$scope.selectedItems = [];
			}

			$scope.getValue = function (field, item, i) {
				return eval('item.' + field.path);
			};


			$scope.toggleDetail = function ($index) {
				if ($scope.openRows.indexOf($index) > -1) {
					$scope.openRows.splice($scope.openRows.indexOf($index), 1);
				} else {
					$scope.openRows.push($index);
					if ($scope.tableConfig.innerTable) {
						var targetEl = $('#table-' + ($scope.id || $scope.$id) + ' table.table:first>.row-' + $index + ' .row-details-' + $index + ' td').first();
						// if inner table already exists, destroy it
						if (targetEl.hasClass("inner-table")) {
							targetEl.removeClass("inner-table");
							targetEl.find("[inner-table='true']").remove();
						}
						var innerTable = angular.element(document.createElement('ng-table'));
						var innerTableConfig;

						if ($scope.tableConfig.innerTable.inheritSetting) {
							innerTableConfig = $.extend(true, {}, $scope.tableConfig, $scope.tableConfig.innerTable);

							// we need this condition, otherwise th deep merge of extend (with true) keep all cells of original array if it's longer then the new one
							if ($scope.tableConfig.innerTable.fields) {
								innerTableConfig.fields = $scope.tableConfig.innerTable.fields;
							}

							if (innerTableConfig.dynamicTableConfig) {
								var innerTableDynamicConfig = innerTableConfig.dynamicTableConfig($scope.data.queryResults[$index]);
								$.extend(innerTableConfig, innerTableDynamicConfig);
							}

							if (innerTableConfig.innerTable) {
								delete innerTableConfig.innerTable;
							}
							if (innerTableConfig.items) {
								delete innerTableConfig.items;
							}
							if (innerTableConfig.data) {
								delete innerTableConfig.data;
							}
						} else {
							innerTableConfig = $.extend(true, {}, $scope.tableConfig.innerTable);
						}

						if (innerTableConfig.dynamicAggregationConfig) {
							if ($scope.tableConfig.useFacetsAsItems) {
								if ($scope.data.facets) {
									innerTableConfig.addedConfig = innerTableConfig.dynamicAggregationConfig($scope.data.facets[0].items[$index], $scope.aggregator);
								}
							} else {
								innerTableConfig.addedConfig = innerTableConfig.dynamicAggregationConfig($scope.data.queryResults[$index], $scope.aggregator);
							}
						}
						if (innerTableConfig.errors) {
							innerTable.attr('errors', JSON.stringify(innerTableConfig.errors));
						}

						if ($scope.data && $scope.data.queryResults) {
							innerTableConfig.parentItem = $scope.data.queryResults[$index];
						} else {
							innerTableConfig.parentItem = $scope.items[$index];
						}

						innerTable.attr('table-config', JSON.stringify(innerTableConfig));
						innerTable.attr('inner-table', true);

						var newScope = $.extend(true, {}, $scope);
						delete newScope.pagination;

						var ela = $compile(innerTable)(newScope);
						targetEl.append(innerTable);

						targetEl.addClass('inner-table');
					}
				}
			};

			if ($scope.tableConfig.watchDate) {
				$scope.$watch('tableConfig.fromDate', function (newValue, oldValue) {
					if (newValue && !_.isEqual(newValue, oldValue)) {
						$scope.aggregator.getFacets(true);
					}
				});
				$scope.$watch('tableConfig.toDate', function (newValue, oldValue) {
					if (newValue && !_.isEqual(newValue, oldValue)) {
						$scope.aggregator.getFacets(true);
					}
				});
			}

            $scope.getListHeight = function () {
                if ($scope.tableConfig.height){
                    if ($scope.pagination) {
                        if ($scope.pagination.totalPages > 1) // magic numbers...
                            return $scope.tableConfig.height - 72 - 57 + 'px';
                        return $scope.tableConfig.height - 67 + 'px';
                    }
                }
                else {
                    return '100%';
                }
            }

			$scope.pagination = {

				from: 0,
				pageSize: $scope.tableConfig.pageSize ? $scope.tableConfig.pageSize : DEFAULT_PAGE_SIZE,
				currentPage: 0,
				total: 0,
				pages: [],
				totalPages: 0,
				next: function (reuseData) {
					if (this.currentPage + 1 === this.totalPages) {
						return;
					}
					this.goTo(this.currentPage + 1, reuseData);
				},
				prev: function (reuseData) {
					if (this.currentPage === 0) {
						return;
					}
					this.goTo(this.currentPage - 1, reuseData);
				},
				goTo: function (page, reuseData) {
					if (this.currentPage != page) {
						if (!$scope.pagination.checkForChanges()) return;
						this.currentPage = page;
						if (reuseData) {
							$scope.pagination.calculatePages();
						} else {
							$scope.queryId++;
							$scope.queryData($scope.queryId);
						}
					}
				},
				checkForChanges: function () {
					var message; // Escaping quotes in messages as a user received them encoded. Can't escape in ie
					if ($scope.$root.ieVersion) {
						message = "You have unsaved changes. Press \'OK\' to select another row and discard your changes or press \'Cancel\' to stay on current row.";
					} else {
						message = "You have unsaved changes. Press 'OK' to select another row and discard your changes or press 'Cancel' to stay on current row.";
					}

					if ($scope.$parent.checkChanges && $scope.$parent.hasChanges && $scope.$parent.hasChanges()) {
						return confirm(message);
					}
					return true;
				},
				calculatePages: function () {
					var i;
					var total = this.total;
					// Used mainly for pie charts, where the actual "data" are the aggregations
					if ($scope.tableConfig.useFacetsAsItems) {
						total = $scope.tableConfig.facets.length;
					}
					this.totalPages = Math.ceil(total / this.pageSize);
					var pagesToshowInPaginator = Math.min(5, (this.totalPages - this.currentPage) + 2);
					pagesToshowInPaginator = Math.min(pagesToshowInPaginator, this.totalPages);
					this.pages = [];
					if (this.currentPage <= 1) {
						for (i = 0; i < pagesToshowInPaginator; i++) {
							this.pages.push(i + 1);
						}
					} else {
						this.pages[0] = this.currentPage - 1;
						for (i = 0; i < pagesToshowInPaginator - 1; i++) {
							this.pages[i + 1] = this.currentPage + i;
						}
					}

					if ($scope.selectedItems && $scope.selectedItems.length > 0 && $scope.items && $scope.items.length > 0 && $scope.tableConfig.mode === 'list') {
						$scope.items.forEach(function(item) {
							var selectedIndex = $scope.selectedItems.indexOf(item);

							if (selectedIndex > -1) {
								$scope.selectedItems.splice(selectedIndex, 1);
							}
						});
					}
				},
				getPageClass: function (page) {
					var classStr = '';
					if (page === (this.currentPage + 1)) {
						classStr += ' active ';
					}

					return classStr;
				},
				restart: function(){
					$scope.pagination.from= 0;
                	$scope.pagination.pageSize= $scope.tableConfig.pageSize ? $scope.tableConfig.pageSize : DEFAULT_PAGE_SIZE;
                	$scope.pagination.currentPage= 0;
                	$scope.pagination.total= 0;
                	$scope.pagination.pages= [];
                	$scope.pagination.totalPages= 0;
				}
			};

			$scope.$watch('pagination.currentPage', function() {
                if ($scope.tableConfig.onPageChange) {
                    $scope.tableConfig.onPageChange();
                }
			});

			$scope.widther = {
				getClass: function (field) {
					if (field.width) {
						return 'col-sm-' + field.width;
					}
					return '';
				},
			};

			$scope.getSortFields = function () {
				var fields = [];
				if ($scope.tableConfig.sortList) {
					for (var index in $scope.tableConfig.sortList) {
						var sort = $scope.tableConfig.sortList[index];
						fields.push({ name: sort.sortField || 'name', path: sort.sortField || 'name', dir: sort.sortDir || 'ASC' });
					}
				} else {
					fields.push({ name: $scope.tableConfig.sortField || 'name', path: $scope.tableConfig.sortField || 'name', dir: $scope.tableConfig.sortDir || 'ASC' });
				}
				return fields;
			};

			$scope.sorter = {
				fields: $scope.getSortFields(),
				sort: function (field, direction) {
					if (field.noSort) {
						return;
					}
					if (this.fields.length === 1) {
						if (field.path === this.fields[0].path) {
							if (!direction) {
								this.fields[0].dir = (this.fields[0].dir === 'ASC' ? 'DESC' : 'ASC');
							}
						} else {
							this.fields[0] = field;
							if (!direction) {
								this.fields[0].dir = 'ASC';
							}
						}
					} else {
						this.fields = [field];
						if (!direction) {
							this.fields[0].dir = 'ASC';
						}
					}

					if (direction) {
						this.fields[0].dir = direction;
					}

					$scope.pagination.goTo(0, true);

					if ($scope.tableConfig.clientSideSort) {
						this.clientSideSort();
					} else {
						$scope.queryId++;
						$scope.queryData($scope.queryId);
					}
				},
				restart: function(){
					$scope.sorter.fields = $scope.getSortFields();
				},
				clientSideSort: function () {
					var targetField = this.fields[0];
					var dirValue = targetField.dir === 'ASC' ? 1 : -1;
                    if ($scope.items === $scope.tableConfig.items) {
                        $scope.items = [];
                        $scope.tableConfig.items.forEach(function (item) {$scope.items.push(item);});

                        //the sort breaks the search because we override $scope.items so we run the search again
                         if ($scope.tableConfig.clientSideSearch) {
                            $scope.clientSideSearch();
                        }
                    }
					$scope.items.sort(function (a, b) {
						if (!a[targetField.path] && a[targetField.path] !== 0) return 1 * dirValue;
						if (!b[targetField.path] && b[targetField.path] !== 0) return -1 * dirValue;
					    if (typeof a[targetField.path] === "string" && typeof b[targetField.path] === "string")
					        return (a[targetField.path].toLowerCase() > b[targetField.path].toLowerCase() ? 1 * dirValue : -1 * dirValue);

						return (a[targetField.path] > b[targetField.path] ? 1 * dirValue : -1 * dirValue);
					});

					$scope.pagination.calculatePages();
				},
				getClass: function (field) {
					if (this.fields) {
						for (var index in this.fields) {
							var sort = this.fields[index];
							if (field.path === sort.path) {
								return (sort.dir === 'ASC' ? 'up' : 'down');
							}
						}
					}
					return '';
				},
			};


			$scope.bucketListOptions = {
				removeItem: true,
				noDisable: true,
				rows: 2,
				onremove: function (item) {
					$scope.aggregator.removeFilter(item);
				},
			};

			$scope.aggregator = {

				facetFields: null,

				facets: null,

				currentFilter: [],

				filters: [],

				currentFacet: null,

				buckets: {},

				displayBuckets: {},

				getFacets: function (timer) {
					var currentBucket,
						bucket;
					var tableQueryConfig = $scope.getQueryConfig();
					var aggregationConfig = { type: this.type, fields: this.facetFields };
					var bucketFields = {};
					for (bucket in $scope.aggregator.buckets) {
						currentBucket = $scope.aggregator.buckets[bucket];

						if (currentBucket.values.length > 0) {
							$scope.aggregator.facetFields.forEach(function (facet) {
								if ((facet.label || facet.id) === bucket) {
									var filterValues = [];
									var currentFacetData = _.findWhere($scope.aggregator.facets, { id: facet.id });

									currentBucket.values.forEach(function (value) {
										for (var i = 0; currentFacetData.items[i]; i++) {
											if ((typeof value.value !== 'undefined' && currentFacetData.items[i].value === value.value) || (typeof value.id !== 'undefined' && currentFacetData.items[i].id === value.id)) {
												filterValues.push(value.id);
												break;
											}
										}
									});

									bucketFields[currentFacetData.id || currentFacetData.label] = {
										label: currentFacetData.id || currentFacetData.label,
										includeMissing: false,
										values: filterValues,
										innerAggregationField: [currentFacetData.innerAggregationField || 'documentGroupId'],
									};
								}
							});
						}
					}
					if ($scope.tableConfig.addFilter) {
						for (bucket in $scope.tableConfig.addFilter) {
							if (!bucketFields[bucket]) {
								currentBucket = $scope.tableConfig.addFilter[bucket];
								bucketFields[bucket] = {
									label: currentBucket.label,
									includeMissing: currentBucket.includeMissing || false,
									values: currentBucket.values,
								};
							}
						}
					}
					var queryConfig = {
						type: $scope.type,
						fields: bucketFields,
					};
					$scope.facets = bucketFields;
					aggregationConfig.rawData = $scope.tableConfig.rawData;
					aggregationConfig.dataConfig = tableQueryConfig;
					aggregationConfig.filter = queryConfig;
					aggregationConfig.index = $scope.tableConfig.index || 'models';
					if ($scope.tableConfig.entityType) {
						aggregationConfig.entityType = $scope.tableConfig.entityType;
					}
					if ($scope.tableConfig.addedConfig) {
						$.extend(aggregationConfig, $scope.tableConfig.addedConfig);
					}

					$scope.aggregationConfig = aggregationConfig;

					var defer = false;
					if (timer) {
						defer = 1000;
					}

					var requestId = $scope.tableConfig.requestId || ('tableReq' + new Date().getTime());
					$scope.loading = true;

					store.fetch({
						id: requestId,
						rt: $scope.tableConfig.rt,
						defer: defer,
						data: $scope.aggregationConfig,
						dataObj: 'json',
						method: $scope.tableConfig.method || 'POST',
						showLoader: $scope.tableConfig.showLoader,
						path: $scope.tableConfig.facetsUrl ? $scope.tableConfig.facetsUrl : '/facets',
						queryParams: { accountId: $state.params.accountId },
						success: function (data) {
							// $scope.facetCollection.items = data.queryResults;
							if (data.facets && data.facets.length > 0) {
								$scope.aggregator.updateFacets(data.facets);
							}

							$scope.update(data.queryResults, data, data.total);
							$scope.data = data;
							$scope.loading = false;
							$scope.firstFetch = true;

							$scope.$digest();
						},
					});
				},

				createBuckets: function () {
					this.facetFields.forEach(function (facet) {
						if (!facet.hide) {
							var facetId = facet.label || facet.id;
							if (!$scope.aggregator.buckets[facetId]) {
                            	$scope.aggregator.buckets[facetId] = {
                            		id: facetId,
                                	label: facetId,
                                	order: facet.order || 999,
                                	subBuckets:{},
                                	values:[]
                            	};
                           	}
                           	if(facet.subLabel && !$scope.aggregator.buckets[facetId].subBuckets[facet.subLabel]){
                            	$scope.aggregator.buckets[facetId].subBuckets[facet.subLabel] = {
                            	    id: facetId,
                            	    label: facetId,
                            	    order: facet.order || 999,
                            		subLabel: facet.subLabel,
									subOrder: facet.subOrder || 999
                            	};
                            }
						}
					});
				},
				changeCurrentBucket: function (bucket) {
					$scope.filterSearch.value = '';
					var $facetsWindow = $scope.$el.find('.filters');
					if ($facetsWindow.hasClass('open')) {
						if ($scope.aggregator.currentFacet.label === bucket.label) {
							$scope.aggregator.currentFacet = {};
							$scope.aggregator.currentFilterdFacetItems = [];
							$facetsWindow.removeClass('open');
							$scope.tableConfig.openFilters = false;
							return;
						}
					} else {
						$facetsWindow.addClass('open');
						$scope.tableConfig.openFilters = true;
					}

					$scope.aggregator.currentFacet = bucket;
					$scope.aggregator.currentSubBucket = bucket.subBuckets.Name;

                    //if there is no sub-bucket "Name" take the one with min subOrder
                    if ($scope.aggregator.currentSubBucket == null){
                        var minSubOrder = Object.keys(bucket.subBuckets).length;
                        var minSubBucketObj = null;
                        for (var subBucketId in bucket.subBuckets) {
                            if (bucket.subBuckets[subBucketId].subOrder < minSubOrder){
                                minSubOrder = bucket.subBuckets[subBucketId].subOrder;
                                minSubBucketObj = bucket.subBuckets[subBucketId];
                            }
                        }
                        $scope.aggregator.currentSubBucket = minSubBucketObj;
                    }
					this.setCurrentBucketValues();
				},
				changeCurrentSubBucket : function (subBucket) {
					$scope.filterSearch.value = '';
					$scope.aggregator.currentSubBucket = subBucket;
					this.setCurrentBucketValues();

				},

				setCurrentBucketValues : function(searchString){
					$scope.aggregator.currentFilterdFacetItems = [];
					var bucketItems = [];
                	this.facetFields.forEach(function (facet) {
                		var facetId = facet.label || facet.id;
                		if (facetId === $scope.aggregator.currentFacet.id) {
                			if(!$scope.aggregator.currentSubBucket || $scope.aggregator.currentSubBucket.subLabel === facet.subLabel){ // get item for facet if no sub bucket or sub bucket is equals to sub facet
                				var currentFacetData = _.findWhere($scope.aggregator.facets, { id: facet.id });
                				if (currentFacetData) {
                					bucketItems = bucketItems.concat(currentFacetData.items);
                				}
                			}
                		}
                	});

                	$scope.aggregator.currentFacet.size = bucketItems.length;
                	bucketItems = _.sortBy(bucketItems, 'count');

                	if (!searchString || searchString === '') {
                		for (let i = bucketItems.length - 1; i >= 0 && i > bucketItems.length - 11; i--) {
                			$scope.aggregator.currentFilterdFacetItems.push(bucketItems[i]);
                		}
                	} else {
                		searchString = $filter('lowercase')(searchString);
                		for (let i = bucketItems.length - 1; i >= 0; i--) {
                			if ($filter('lowercase')(bucketItems[i].label).indexOf(searchString) !== -1) {
                				$scope.aggregator.currentFilterdFacetItems.push(bucketItems[i]);
                			}

                			if ($scope.aggregator.currentFilterdFacetItems.length > 10) {
                				break;
                			}
                		}
                	}
				},
				addFilter: function (filter, bucket) {
					var currentBucket = bucket || $scope.aggregator.buckets[$scope.aggregator.currentFacet.label];
					var filterPos = _.find(currentBucket.values, { label: filter.label || filter });

					if (filterPos) {
						currentBucket.values.splice(currentBucket.values.indexOf(filterPos), 1);
					} else {
						if (!filter.id && filter.id !== 0) {
							filter.id = (filter.value || filter.value === 0 || filter.value === false) ? filter.value : filter.label;
						}
						if (!filter.name) {
							filter.name = $filter('capitalize')(filter.label);
						}
						currentBucket.values.push(filter);
						$scope.lastFilter = currentBucket.label;
					}

					$scope.pagination.currentPage = 0;
					$scope.aggregator.getFacets();
				},
				removeFilter: function (filter) {
					$scope.pagination.currentPage = 0;
					$scope.aggregator.getFacets();
				},
				updateFacets: function (newFacets) {
					// if its the first time - facets = new facets
					if (!$scope.aggregator.facets) {
						$scope.aggregator.facets = [];
						newFacets.forEach(function (facet) {
							$scope.aggregator.facets.push(facet);
						});
						return;
					}

					// for values in the filter - do nothing
					// for values not in the filter - update number
					$scope.aggregator.facets.forEach(function (facet) {
						var matchingNewFacet = _.find(newFacets, { id: facet.id });
						var currentBucket = $scope.aggregator.buckets[facet.label] || $scope.aggregator.buckets[facet.id];

						if (currentBucket.values.length === 0 || (!$scope.lastFilter || ((facet.label !== $scope.lastFilter && facet.id !== $scope.lastFilter)))) {
							facet.items.forEach(function (item) {
								var matchingItem = _.find(matchingNewFacet.items, { label: item.label });

								if (matchingItem) {
									item.count = matchingItem.count;
								} else {
									item.count = 0;
								}
							});
						}
					});
				},

				isFilterActive: function (filter, facet) {
					var currentBucket = $scope.aggregator.buckets[facet.label];
					return !!_.find(currentBucket.values, { label: filter.label });
				},

			};

			$scope.toggleFilterWindow = function (id) {
				id += 1;
				if ($('#facet-drop-' + id).css('display') === 'none') {
					$scope.$root.$emit('$openPopup', 'facet-drop-' + id, 'facet-btn-' + id, { topMod: -29 });
				} else {
					$scope.$root.$emit('$closePopup', 'facet-drop-' + id);
				}
			};


			$scope.queryData = function (queryId) {
				if ($scope.tableConfig.facets) {
					$scope.aggregator.createBuckets();
					$scope.aggregator.getFacets();
					return;
				}

				var url =  $scope.tableConfig.dataURL ? $scope.tableConfig.dataURL($scope.tableConfig.parentItem) : null;

				// Not using the ngTable fetching but instead using the tableConfig.parseData() to feed the table data
				if (!url && $scope.tableConfig.parseData) {
					if ($scope.tableConfig.useRegularUpdate) {
						var items = $scope.tableConfig.parseData();
						$scope.update(items, null, items.length);
					} else {
						$scope.items = $scope.tableConfig.parseData();
						$scope.tableConfig.items = $scope.items;

						if ($scope.tableConfig.afterUpdate) {
							$scope.tableConfig.afterUpdate();
						}
						commonAfterUpdate();
						autoSelectRow();
					}

					return;
				}

				// no data
				if (typeof url === 'object') {
					$scope.update([], null, 0);
					return;
				}

				var requestId = $scope.tableConfig.requestId || ('tableReq' + new Date().getTime());
				$scope.loading = true;

				store.fetch({
					data: $scope.getQueryConfig(),
					rt: $scope.tableConfig.rt,
					id: requestId,
					dataObj: 'dataConfig',
					method: $scope.tableConfig.method || 'POST',
					showLoader: $scope.tableConfig.showLoader,
					path: url,
					success: function (data) {
						$scope.loading = false;
						if (!queryId || $scope.queryId === queryId) {
							if (!data) {
								data = {
									items: [],
									total: 0,
								};
							}
							var parsedItems = $scope.tableConfig.parseData ? $scope.tableConfig.parseData(data.items || data, $scope.tableConfig.type, $scope.tableConfig.parentItem) : (data.items || data);

							$scope.update(parsedItems, data, data.hasOwnProperty("total") ? data.total : data.length || Object.keys(data).length);

							if ($scope.tableConfig.clientSideSort) {
								$scope.sorter.clientSideSort();
							}

							autoSelectRow();
						}
						if ($scope.tableConfig.continuous && data.done) {
							IntervalService.cancelDynamicInterval( $scope.$id, 'ngTableQueryData');
							$scope.doneContinuous = true;
						}
						$scope.firstFetch = true;

						// in case of innertable we don't want it's digest to mess with ours
						if ($scope.tableConfig.innerTable) {
							$timeout(()=>{},0);
						} else {
							$scope.$digest();
						}
					},
				});
			};

			function autoSelectRow() {
				var itemToSelect = null;
				if ($scope.tableConfig.selectedId) {
					var index = 0;
					$scope.items.forEach(function (item) {
						if (item[$scope.tableConfig.selectIdentifier || 'id'] === $scope.tableConfig.selectedId) {
							itemToSelect = index;
						}
						index++;
					});
				}

				if ($scope.tableConfig.noAutoSelect) {
					if (itemToSelect) {
						$scope.selectedIndexes = [itemToSelect];

						if ($scope.tableConfig.scrollToSelected) {
							$timeout(function () {
								var $targetRow = $($element[0]).find('.selectedRow');
								$($scope.tableConfig.containerEl).scrollTop($targetRow.position().top);
							}, 100, false);
						}
					}
				} else {
					if (itemToSelect == null) itemToSelect = 0;
					var selectedItem = $scope.items ? $scope.items[itemToSelect] : null;
					$scope.selectRow(itemToSelect, 'row', null, selectedItem, true);
				}
			}

			$scope.addRow = function () {
				$scope.tableConfig.addAction();
				$scope.tableConfig.refreshViewItems = new Date().getTime();
			};
			$scope.update = function (items, data, total) {
				// in case we want to use the facets as items, like for pie chart, where the aggregation are the real data
				var itemsForChart = items;
				if ($scope.tableConfig.processData) {
					itemsForChart = ($scope.tableConfig.useFacetsAsItems && data.facets && data.facets.length > 0) ? data.facets[0].items : items;

					if ($scope.tableConfig.useFacetsAsItems) {
						itemsForChart = $scope.tableConfig.processData(itemsForChart, data, $scope.tableConfig.expand);
					} else {
						$scope.tableConfig.processData(itemsForChart, data, $scope.tableConfig.expand);
					}
				}
				$scope.items = itemsForChart;
				$scope.tableConfig.items = itemsForChart;

				$scope.pagination.total = total;
				$scope.pagination.calculatePages();
				$scope.openRows = [];

				$timeout(function () {
					if ($scope.tableConfig.afterUpdate) {
						$scope.tableConfig.afterUpdate();
					}
				}, 1, false);

				commonAfterUpdate();
			};

			function commonAfterUpdate() {
				if ($scope.tableConfig.searchId && $scope.items) {
					var requestedItem = $scope.items.filter(function(item){ return item.id == $scope.tableConfig.searchId});

					if (requestedItem.length === 1) {
						$scope.searchVal = requestedItem[0].name;
						$scope.tableConfig.searchVal = requestedItem[0].name;
					}
				}
				if ($scope.tableConfig.clientSideSearch) {
					$scope.clientSideSearch();
				}

				// setting up the sticky head
				if ($scope.tableConfig.stickyHead) {
					let jqEl = $($element[0]);
					$scope.alternativeHeadEl = jqEl.find('.table-header:first-of-type');
					$scope.tableEl = jqEl.find('.table-data:first-of-type');
				}
			}

			$scope.getQueryConfig = function () {
				$scope.fromItem = !$scope.tableConfig.clientSidePaging ? $scope.pagination.currentPage * $scope.pagination.pageSize : 0;
				var limit = !$scope.tableConfig.clientSidePaging ? $scope.pagination.pageSize : -1;
				var filterField;
				if($scope.tableConfig.dataFilter){
					$scope.filterVal = $scope.tableConfig.dataFilter.selectedOption == 'ALL' ? '' : $scope.tableConfig.dataFilter.selectedOption;
					filterField = $scope.tableConfig.dataFilter.field;
				}
				var urlFilter = GeneralUtilsService.getParams($location,true,"filterVal");
				if(!$scope.filterVal && urlFilter){
					$scope.filterVal = urlFilter;
					filterField = GeneralUtilsService.getParams($location,true,"filterField");
					$scope.externalFilter = true;
				}
				var orders = [];
				if (!$scope.tableConfig.clientSideSort) {
					for(var index in $scope.sorter.fields){
						var sort = $scope.sorter.fields[index];
						orders.push({"path":sort.path,"dir":sort.dir});
					}
				}
				return {
					"dateField": $scope.tableConfig.dateField || "",
					"fromDate": $scope.tableConfig.fromDate || 0,
					"toDate": $scope.tableConfig.toDate || 0,
					"from":$scope.fromItem,"limit":limit,
					"search": $scope.tableConfig.clientSideSearch? '' : $scope.searchVal,
					"searchField":$scope.tableConfig.searchField?$scope.tableConfig.searchField:"name",
					"searchFields":$scope.tableConfig.searchFields?$scope.tableConfig.searchFields:[],
					getById: ($scope.tableConfig.searchId || $scope.tableConfig.searchId === 0)? parseInt($scope.tableConfig.searchId) : null,
					"filter":$scope.filterVal,
					"filterField":filterField,
					"orders": orders,
					"type":$scope.tableConfig.type,
					"showOthers": $scope.tableConfig.showOthers,
					interval: $scope.tableConfig.interval,
				};
			};


			var lastSelectedRow = 0;

			$scope.select = function (selectedItem, $event, index, noUnselect, noAutoCheckboxSelect) {
				if ($event) {
					$event.stopPropagation();
				}

				if ($event && $($event.currentTarget).hasClass('checkbox')) {
					if ($event && $event.shiftKey) {
						if (lastSelectedRow !== index) {
							var diff = lastSelectedRow - index;
							var absDiff = Math.abs(diff);
							if (absDiff > 1) {
								for (var k = 1;k < absDiff;k++) {
									var newIndex = index + (diff < 0 ? -k : k);
									$scope.select($scope.tableConfig.items[newIndex], null, newIndex, true);
								}
							}
						}
					}
					lastSelectedRow = index || 0;
				} else {
					var currentIndex = -1;
					for(var i = 0 ; i < $scope.selectedItems.length ; i++){
						if(compareByIdentifier(selectedItem,$scope.selectedItems[i])){
							currentIndex = i;
							break;
						}
					}
					if (currentIndex >= 0) {
						if (!noUnselect) {
							$scope.selectedItems.splice(currentIndex,1);
							selectedItem.$selected = false;
						}
					} else {
						if (!noAutoCheckboxSelect && (!$scope.tableConfig.unselectable || !$scope.tableConfig.unselectable(selectedItem))) {
							$scope.selectedItems.push(selectedItem);
						}

						selectedItem.$selected = true;
					}
				}
			};
			$scope.isSelected = function(currItem){
				var found = false;
				$scope.selectedItems.forEach(function(item){
					if(compareByIdentifier(item,currItem)) {
						found = true;
					}
				});
				return found;
			};

			function compareByIdentifier(item, itemToSelect) {
			    var selectIdentifier = $scope.tableConfig.selectIdentifier;
			    return item && ((item.id && (item.id === itemToSelect.id)) ||
			                    (selectIdentifier == "item" && item == itemToSelect ) ||
			                    (item[selectIdentifier] && (item[selectIdentifier] === itemToSelect[selectIdentifier])));
			}

			let entitiesToDelete = [];

			$scope.removeItems = function (){
				const len = $scope.selectedItems.length;
				const maxItemsPerDelete = 10;
				entitiesToDelete = $scope.selectedItems;
				if ($scope.tableConfig.customDelete && len > maxItemsPerDelete) {
					$scope.$root.alert(`${len} items selected. Please select up to ${maxItemsPerDelete} items.`);
					return;
				}
				if (len === 0) {
					$scope.$root.alert('Please select items to delete');
					return;
				}
				let itemsMessage = len === 1 ? 'one item - ' : len + ' items - ';
				let itemsToDelete = [];
				let i = 0;
				$scope.selectedItems.forEach(function(item){
				    if (item.id > 0) {
					    itemsToDelete.push(item.id);
				    }
					var itemName = $scope.tableConfig.nameField ? item[$scope.tableConfig.nameField] : item.name;
					itemsMessage += itemName;
					i++;
					if(i == $scope.selectedItems.length - 1) {
						itemsMessage += " and ";
					}
					else if(i < $scope.selectedItems.length - 1) {
						itemsMessage += ", ";
					}
				});
				var extraMessage = $scope.tableConfig.removeConfirmation ? $scope.tableConfig.removeConfirmation($scope.selectedItems) : '';
				var confirmMessage = extraMessage ? ("Are you sure you want to remove " +  itemsMessage + "?" + ' ' + extraMessage) : ("Are you sure you want to remove " +  itemsMessage + "?");
				$scope.$root.confirm(confirmMessage, function(){
					$scope.selectedItems = [];
					$scope.selectedIndexes = [];
					store.remove({
						path: $scope.tableConfig.removeURL ? $scope.tableConfig.removeURL() : null,
						type: $scope.tableConfig.type,
						accountId: $state.params.accountId,
						items: itemsToDelete,
						success: function (data) {
							$scope.$root.handleServerResponse(data, "", $filter('capitalize')(itemsMessage) + " removed successfully", $scope.reloadPage);
							if($scope.onSuccessfulItemRemove)
								$scope.onSuccessfulItemRemove(entitiesToDelete, data);
							entitiesToDelete =[];
						}
					});
				});
				$scope.tableConfig.refreshViewItems = new Date().getTime();
			};

			$scope.reloadPage = function () {
				$timeout(function () {
					$scope.queryId = 0;
					$scope.queryData($scope.queryId);
				}, 500);
			};


			$scope.selectRow = function (index, clickType, $event, item, autoSelection) {
				if ($event && !$scope.tableConfig.allowPropagation) {
					$event.stopPropagation();
				}

				if ($scope.tableConfig.onSelect && (!$scope.tableConfig.expanderClick || clickType === 'row')) {
					if ($scope.tableConfig.hasChanges && $scope.tableConfig.hasChanges()) {
						$scope.$root.confirm("You have unsaved changes. Press 'OK' to select another row and discard your changes or press 'Cancel' to stay on current row.", function () {
							if (item) {
								$scope.selectedItems.splice(0, $scope.selectedItems.length);
								$scope.select(item);
							}
							$scope.doSelectRow(index, item);
						});
					} else {
						if (item) {
							if ($scope.tableConfig.multiSelect) {
								//$scope.selectedItems.push(item);
							} else {
								$scope.selectedItems.splice(0, $scope.selectedItems.length);
							}

							$scope.select(item, null, null, null, autoSelection && $scope.tableConfig.noAutoCheckboxSelect);
						}
						$scope.doSelectRow(index, item);
					}
				}

				if ($scope.tableConfig.expandRow || ($scope.tableConfig.innerTable && (!$scope.tableConfig.expanderClick || clickType === 'expander'))) {
					$scope.toggleDetail(index);
				}

				if ($scope.selectedItemsChanged) {
					$scope.selectedItemsChanged({newSelections: $scope.selectedItems});
				}
			};

			$scope.removeURLFilters = function () {
				GeneralUtilsService.removeParam($location, 'filterField');
				GeneralUtilsService.removeParam($location, 'filterVal');
				$scope.filter = null;
				$scope.filterVal = null;
			};

			$scope.doSelectRow = function (index, item) {
				if ($scope.tableConfig.items && $scope.tableConfig.items.length > 0) {
					if ($scope.tableConfig.deselect && $scope.selectedIndexes.indexOf(index) > -1) {
						if ($scope.tableConfig.multiSelect) {
							$scope.selectedIndexes.splice($scope.selectedIndexes.indexOf(index), 1);
						} else {
							$scope.selectedIndexes = [];
						}
					} else {
						if ($scope.tableConfig.multiSelect) {
							$scope.selectedIndexes.push(index);
						} else {
							$scope.selectedIndexes = [index];
						}
					}

					if (!item) {
						item = $scope.items[index];
					}
					if ($scope.tableConfig.onSelect) {
					    $scope.tableConfig.onSelect($scope.tableConfig.items.indexOf(item), item); // We get the real index for cases when filtered with client side search
					}
				} else if ($scope.tableConfig.emptyTable) {
					$scope.tableConfig.emptyTable();
				}
			};

			/* $($element[0]).click(function(event){
			 temporarly disabled inner filter as they don't work anymore and we're not sure we want them to work
			 var $eventTarget = $(event.target);
			 if($eventTarget.hasClass('filterable')){
			 var classNames = $eventTarget.attr('class');
			 var filterStart = classNames.indexOf("filter-") + 7;
			 var filterField = $.trim(classNames.substr(filterStart, classNames.indexOf(" ", filterStart) - filterStart));
			 var targetString = $eventTarget.data('id') || $eventTarget.text();
			 $scope.aggregator.addFilter({label: $.trim(targetString)}, $scope.aggregator.buckets[filterField]);
			 }
			 });*/

			if ($scope.tableConfig.fixedLayout || $scope.tableConfig.lookup) {
				var $elementJQ = $($element[0]);
				$elementJQ.on('mouseenter', 'td', function (event) {
					if ($scope.innerTable) {
						event.stopPropagation();
					}

					var $td = $(event.currentTarget || event.target);
					var $cell = $td.children('table-cell');
					if ($scope.tableConfig.lookup) {
						$scope.tableConfig.lookup($td, $cell.text(), event);
					}
				});

				$elementJQ.delegate('td', 'mouseleave', function (event) {
					if ($scope.tableConfig.lookup) {
						$scope.tableConfig.lookup(null, null, event, true);
					}
				});
			}

			$scope.expandRow = function (item) {
				return ($scope.tableConfig.expandRow || ($scope.tableConfig.innerTable && $scope.tableConfig.expand && (typeof $scope.tableConfig.expand !== 'function' || $scope.tableConfig.expand(item))));
			};

			$scope.isEmpty =  function (map) {
               for(var key in map) {
                  return !map.hasOwnProperty(key);
               }
               return true;
            };

			$scope.isItemDisabled = function (item) {
				return item.enabled === false || item.ruleEnabled === false;

			};
		},
		link: function ($scope, element, attr) {
			var $document = $(document);
			$scope.$el = $(element[0]);

			if (!$scope.tableConfig) {
				return;
			}

			if ($scope.tableConfig.facets) {
				$scope.aggregator.facetFields = $scope.tableConfig.facets;
				$scope.aggregator.type = $scope.tableConfig.type;
				// $scope.aggregator.getFacets();
			}


			if ($scope.tableConfig.searchVal) {
				$scope.searchVal = $scope.tableConfig.searchVal;
			}

			$scope.$watch('searchFor', function() {
				if($scope.searchFor) {
					$scope.searchVal = $scope.searchFor;
				} else {

				}
			});

			$document.on('keydown', checkShiftDown);
			$document.on('keyup', checkShiftUp);

			function checkShiftDown($event) {
				if ($event.which === 16) {
					$scope.$el.addClass('unselectable');
				}
			}

			function checkShiftUp($event) {
				if ($event.which === 16) {
					$scope.$el.removeClass('unselectable');
					if ($event.target.tagName.toUpperCase() === 'INPUT' || $event.target.tagName.toUpperCase() === 'TEXTAREA') {
						return;
					}
					window.getSelection().removeAllRanges();
				}
			}

			$scope.clientSideSearch = function () {
				var currentItem;
				var searchValue = angular.copy($scope.searchVal);

				if ($scope.selectedIndexes.length > 0) {
					currentItem = $scope.items[$scope.selectedIndexes[0]];
				}

				if (searchValue && searchValue !== '') {
					searchValue = searchValue.toLowerCase();

					$scope.items = [];

					if ($scope.tableConfig.items && angular.isArray($scope.tableConfig.items)) {
						$scope.tableConfig.items.forEach(function (item) {
							var found = false;

							if ($scope.tableConfig.searchPredicate) {
							    found = $scope.tableConfig.searchPredicate(item, searchValue);
							    if (found)
							        $scope.items.push(item);
							} else {
							    var fieldsToSearch = angular.copy($scope.tableConfig.fields);
                                if ($scope.tableConfig.extraFieldsToSearch) {
                                	fieldsToSearch = fieldsToSearch.concat($scope.tableConfig.extraFieldsToSearch);
                                }

                                for (var field in fieldsToSearch) {
                                	var currentField = fieldsToSearch[field];
                                	var currentFieldValue = item[currentField.path];
                                	if (!currentField.noSearch) {
                                		switch (typeof currentFieldValue) {
                                			case 'string':
                                				if ($scope.searchVal === $scope.tableConfig.searchVal) {
                                					if (currentFieldValue.toLowerCase() === searchValue) {
                                						$scope.items.push(item);
                                						found = true;
                                					}
                                				} else if (currentFieldValue.toLowerCase().indexOf(searchValue) >= 0) {
                                					$scope.items.push(item);
                                					found = true;
                                				}
                                				break;
                                			case 'object':
                                				if (currentFieldValue instanceof Array) {
                                					for (var i = 0; currentFieldValue[i]; i++) {
                                						var innerItem = currentFieldValue[i];
                                						var innerItemValue = currentField.searchField ? (innerItem[currentField.searchField] ? innerItem[currentField.searchField] : innerItem.id) : innerItem;

                                						if ($scope.searchVal === $scope.tableConfig.searchVal) {
                                							if (innerItemValue.toLowerCase() === searchValue) {
                                								$scope.items.push(item);
                                								found = true;
                                							}
                                						} else if (innerItemValue.toLowerCase().indexOf(searchValue) >= 0) {
                                							$scope.items.push(item);
                                							found = true;
                                						}

                                						if (found) {
                                							break;
                                						}
                                					}
                                				}
                                				break;
                                		}
                                	}

                                	if (found) {
                                		break;
                                	}
                                }
							}
						});

						if (currentItem) {
							if ($scope.items.indexOf(currentItem) > -1) {
								$scope.selectedIndexes = [$scope.items.indexOf(currentItem)];
							} else {
								$scope.doSelectRow(0);
							}
						}
					}
				} else {
				    $scope.items = [];
				    if ($scope.tableConfig.items)
				        $scope.tableConfig.items.forEach(function (item) {$scope.items.push(item);});
					if (currentItem) {
						$scope.selectedIndexes = [$scope.items.indexOf(currentItem)];
					}
				}
                if ($scope.tableConfig.clientSideSort) {
                    $scope.sorter.clientSideSort();
                }
				$scope.pagination.total = $scope.items.length;
				$scope.pagination.calculatePages();
			};

			$scope.clearSearch = function () {
				$scope.tableConfig.searchVal = null;
				$scope.tableConfig.searchId = null;
				$scope.searchVal = '';
			};

			$scope.$watch('searchVal', function (newValue, oldValue) {
				if (typeof newValue === 'undefined') {
					return;
				}
				if (($scope.tableConfig.searchId || $scope.tableConfig.searchId === 0)) { // when filtering by search id we don't want the search to actually search
					$scope.tableConfig.searchId = null;
					return;
				}

				if ($scope.searchTimer) {
					$timeout.cancel($scope.searchTimer);
				}

				if ($scope.tableConfig.clientSideSearch) {
					$scope.pagination.goTo(0, true);
					$scope.clientSideSearch();
				} else {
					$scope.pagination.currentPage = 0;
					$scope.aggregator.facets = null;

					$scope.queryId++;
					$scope.searchTimer = $timeout(function () {
						if ($scope.tableConfig.onSearch) {
							$scope.tableConfig.onSearch(newValue);
						}
						$scope.queryData($scope.queryId);
						$scope.searchTimer = null;
					}, ($scope.tableConfig.searchDelay || 300), false);
				}
				$scope.tableConfig.searchVal = $scope.searchVal;
			});

			if ($scope.tableConfig.pageSize) {
            	$scope.$watch('tableConfig.pageSize', function (newValue, oldValue) {
            		$scope.pagination.restart();
                });
            }

            if ($scope.tableConfig.sortList) {
            	$scope.$watch('tableConfig.sortList', function (newValue, oldValue) {
            		$scope.sorter.restart();
                });
            }

			$scope.filter = function () {
				$scope.queryData($scope.queryId);
			};

			$scope.liveFilter = (item) => {
				if ($scope.tableConfig.liveFilter) return $scope.tableConfig.liveFilter(item);
				return true;
			};

			$scope.$watch('datamodified', function (newValue, oldValue) {
				if ($scope.datamodified) {
					freshGet();
				}
			});

			// used when updating the viewed items that are separated from the tableConfig.items (in case of client side search/sort/page)
			$scope.$watch('tableConfig.refreshViewItems', function(newValue, oldValue) {
				if (newValue) {
				    updateView();
				}
			});

            if ($scope.tableConfig.clientSideSearch || $scope.tableConfig.clientSideSort) {
                $scope.$watchCollection('tableConfig.items', function(newValue) {
                    if (newValue) {
                        updateView();
                    }
                });
            }

			function updateView() {
			    if ($scope.tableConfig.items && $scope.tableConfig.items !== $scope.items) {
                    $scope.items = [];
                    $scope.tableConfig.items.forEach(function (item) {$scope.items.push(item);});
                    if ($scope.tableConfig.clientSideSearch) {
                        $scope.clientSideSearch();
                    }
                    if ($scope.tableConfig.clientSideSort) {
                        $scope.sorter.clientSideSort();
                    }
                }

                if (!$scope.items) {$scope.items = [];}
                initSelectedIndexes();
			}

			function freshGet() {
				$scope.queryId++;
				if (!$scope.tableConfig.keepPageOnRefresh) {
					$scope.pagination.currentPage = 0;
				}
				// $scope.aggregator.facets = null;
				$scope.aggregator.currentFacet = null;
				$scope.aggregator.currentFilterdFacetItems = [];
				$scope.$el.find('.filters').removeClass('open');
				if (!$scope.items) {$scope.items = [];}
				initSelectedIndexes();
				if ($scope.tableConfig.continuous) {
                    $scope.doneContinuous =false;
					IntervalService.dynamicInterval(queryDataWithId, $scope.$id, 'ngTableQueryData', true);
                }
                else {
					queryDataWithId();
				}
			}

            let queryDataWithId = () => {
				$scope.queryData($scope.queryId);
			}

			function initSelectedIndexes() {

			    $scope.selectedIndexes = $scope.selectedItems.map(function(item) { return $scope.items.indexOf(item)});
			}


			if (!$scope.tableConfig.defer) {
				$scope.queryData($scope.queryId);
			}


			angular.element(document).ready(function () {
				$scope.$el.find('.actions a').tooltip();
			});

			$scope.toggleMoreButtons = function ($event) {
				$scope.$root.toggleDropDown('list-more-' + ($scope.id ? $scope.id : $scope.$id), $event);
			};

			$scope.openSort = function ($event) {
				$scope.$root.toggleDropDown('sort-' + ($scope.id ? $scope.id : $scope.$id), $event);
			};

			$scope.anyClick = function (bucket) {
				$scope.aggregator.changeCurrentBucket(bucket);
			};

			$timeout(function () {
				$scope.search = function () {
					var searchString = $scope.filterSearch.value;
					$scope.aggregator.setCurrentBucketValues(searchString);
				};
			}, 0, false);

			$scope.showInlineSearch = function () {
				if (!$scope.showTitleSearch) {
					$scope.showTitleSearch = true;
					$timeout(function () {
						$('#titleSearch-' + ($scope.id ? $scope.id : $scope.$id)).focus();
					}, 0, false);
				}
			};

			function checkInlineSearch(e) {
				if (!$scope.searchVal || $scope.searchVal === '') {
					if ($(e.target).parents('.titlesearch').length === 0) {
						$scope.showTitleSearch = false;
					}
				}
			}

			$('body').on('click', checkInlineSearch);

			$scope.$on('$destroy', function () {
				$('body').off('click', checkInlineSearch);
				$document.off('keydown', checkShiftDown);
				$document.off('keyup', checkShiftUp);
				$scope.$el.find('.actions a').tooltip('destroy');
				$scope.$el.find('*').off();
				IntervalService.cancelDynamicInterval($scope.$id, 'ngTableQueryData');
			});

			$scope.hasCheckboxes = function (){
                return !$scope.tableConfig.hideCheckboxes && ($scope.tableConfig.actions || $scope.tableConfig.selectedItems != null);
			}
		},
	};
}]);

baseApp.directive('tableCell', ['$compile', function ($compile) {
	return {

		link: function (scope, element, attrs) {
			var field = scope.innerField ? scope.innerField : scope.field;
			var fn;

			if (field.groupedFields) {
                for (var i = 0; i < field.groupedFields.length; i++) {
                    if (field.groupedFields[i].predicate(scope.item)) {
                        field = field.groupedFields[i];
                        break;
                    }
                }
			}

			if (scope.compiledTemplates[field.label]) {
				fn = scope.compiledTemplates[field.label];
			} else {
				var template = field.template;
				if (!template) {
					template = attrs.facets ? '<span>{{aggregator.getFieldValue(item,field) | capitalize}}</span>' : '<span>{{getValue(field,item)}}</span>';
					fn = $compile(template);
					scope.compiledTemplates[field.label] = fn;
				} else if (typeof template === 'object') {
					template = '<span>' + template[scope.$parent.item.type] + '</span>';
					fn = $compile(template);
				} else {
					template = '<span>' + template + '</span>';
					fn = $compile(template);
					scope.compiledTemplates[field.label] = fn;
				}
			}
			fn(scope, function (cloned, scope) {
				element.append(cloned);
			});
			$('[data-toggle="tooltip"]').tooltip();
		},
	};
}]);

baseApp.directive('wizard', ['$timeout', function ($timeout) {
	return {
		templateUrl: '/public/directives/wizard.html',
		scope: {
			steps: '=',
			url: '@',
		},
		controller: function ($scope) {
			$scope.currStep = 0;
			$scope.goTo = function (index) {
				$scope.currStep = index;
				$scope.getStepData();
			};

			$scope.getStepData = function () {
				store.fetch({
					path: $scope.url,
					queryParams: { step: $scope.currStep },
					success: function (data) {
						$scope.stepData = data;
					},
				});
			};
		},
		link: function ($scope) {
			$scope.getStepData();
		},
	};
}]);

// Please note !!
// this directive does not have isolated scope. why - I don't want to create too many scopes
// if you need more than one in a page - expand by adding scope + probably watches for the scope values
baseApp.directive('progressbar', ['$state', '$interval', 'IntervalService', function ($state, $interval, IntervalService) {
	return {
		templateUrl: '/public/directives/progressbar.html',
		controller: function ($scope) {
		    function redirectTo(path) {
		        window.location=path + "&accountId=" + $state.params.accountId;
            }
			$scope.getProgress = function () {
				if ($scope.progressId) {
					store.fetch({
						path: '/progress',
						queryParams: { id: $scope.progressId },
						success: function (data) {
							$scope.progress = data;
							if (!$scope.progress || $scope.progress.progress === 100 || $scope.progress.status === 'ERROR') {
								IntervalService.cancelDynamicInterval($scope.$id + $scope.progressReset, 'progressBarProgress');
								if ($scope.progressFinish){
									$scope.progressFinish();
								}
							}
							$scope.$digest();
						},
					});
				}
			};

			$scope.$on('$destroy', function () {
				IntervalService.cancelDynamicInterval($scope.$id + $scope.progressReset, 'progressBarProgress');
			});
		},
		link: function ($scope) {

			$scope.$watch('progressReset', (newValue, oldValue) => {
				if (oldValue){
					IntervalService.cancelDynamicInterval($scope.$id + oldValue, 'progressBarProgress');
				}
				if (newValue) {
					IntervalService.dynamicInterval($scope.getProgress, $scope.$id + newValue, 'progressBarProgress', true);
				}
			});
		},
	};
}]);

